export const SET_IS_LOADING = 'SET_IS_LOADING';
export const SET_IS_FETCHING = 'SET_IS_FETCHING';
export const SET_FILTERS = 'SET_FILTERS';
export const APPLY_PRESET = 'APPLY_PRESET';

export interface IAction {
  type: string;
  payload: any;
}

export interface IContext {
  state: any;
  dispatch: ({ type, payload }: IAction) => any;
}
